export { default as ClinicalStatusEditTemplate } from './ClinicalStatusEditTemplate';
export { default as ClinicalStatusListTemplate } from './ClinicalStatusListTemplate';
